import {translations} from 'presentation/translations-new';

const cards = translations['pt-br'].privateFlow.refund.serviceType.cards;

export const SelectTypeOptionLabels = {
	CONSULTA: cards.consult,
	EXAMES: cards.simpleExam,
	INTERNACAO: cards.hospitalization,
	TERAPIAS: cards.therapy,
} as const;

export const SelectTypeOptionCodes = {
	CONSULTA: '1',
	EXAMES: '3',
	INTERNACAO: '4',
	TERAPIAS: '6',
} as const;

type SelectTypeOptionKey = keyof typeof SelectTypeOptionLabels;

type SelectTypeOptionValue =
	(typeof SelectTypeOptionLabels)[keyof typeof SelectTypeOptionLabels];


type SelectTypeV2Props = {
	handleNextStep: () => void;
};

export type {SelectTypeOptionKey, SelectTypeOptionValue, SelectTypeV2Props};